import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  FiMenu,
  FiX,
} from "react-icons/fi";
import { useNavigate, Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";

const Header = () => {
  const navigate = useNavigate();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(window.scrollY);
  const [showResources, setShowResources] = useState(false);
let timeout;
  const toggleMobileNav = () => setMobileNavOpen((prev) => !prev);

  const handleNavClick = (section) => {
    if (window.location.pathname === "/") {
      const el = document.getElementById(section);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/#${section}`);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setIsVisible(currentScrollPos < prevScrollPos || currentScrollPos < 50);
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos]);

  return (
    <HeaderContainer>
      <HeaderWrapper isVisible={isVisible}>
        {/* Logo */}
        <LeftSection
          onClick={() => {
            navigate("/");
            window.scrollTo({ top: 0, behavior: "smooth" });
            setMobileNavOpen(false);
          }}
        >
          <Logo
            src="https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Untitled_design_4_abf43933-4ac4-44bf-a933-92e15b3e8c13.png?v=1767814970"
            alt="LK-EDUCATIONS Logo"
          />
        </LeftSection>

        {/* Desktop Nav */}
        <CenterSection>
          <NavLink onClick={() => navigate("/")}>Home</NavLink>
          <NavLink onClick={() => navigate("/about")}>About Us</NavLink>
          <NavLink onClick={() => handleNavClick("services")}>Courses</NavLink>
          <NavLink onClick={() => handleNavClick("contact")}>Contact Us</NavLink>
          <NavLink onClick={() => handleNavClick("faq")}>Help</NavLink>
          <NavLink onClick={() => handleNavClick("gallery")}>Gallery</NavLink>
          <NavLink onClick={() => navigate("/certifications")}>Certifications</NavLink>

          {/* Resources Dropdown */}
      {/* Resources Dropdown */}
{/* Resources Dropdown */}

<ResourcesWrapper
  onMouseEnter={() => {
    clearTimeout(timeout); // cancel any pending close
    setShowResources(true); // open immediately
  }}
  onMouseLeave={() => {
    timeout = setTimeout(() => setShowResources(false), 300); // close after 300ms
  }}
>
  <NavLink>
    Resources
  </NavLink>

  {showResources && (
    <Dropdown>
      <DropdownItem onClick={() => navigate("/tallycalculas")}>
        Tally Calculas
      </DropdownItem>
      <DropdownItem onClick={() => navigate("/govtskills")}>
        Govt. Skills Program
      </DropdownItem>
    </Dropdown>
  )}
</ResourcesWrapper>


          <NavLink onClick={() => handleNavClick("placement")}>Placement</NavLink>
        </CenterSection>

        {/* Mobile Menu Icon */}
        <RightSection>
          <MobileMenuIcon onClick={toggleMobileNav}>
            {isMobileNavOpen ? <FiX /> : <FiMenu />}
          </MobileMenuIcon>
        </RightSection>

        {/* Mobile Nav (ALL LINKS INCLUDED) */}
        <MobileNav isVisible={isMobileNavOpen}>
          {[
            { label: "Home", action: () => navigate("/") },
            { label: "About Us", action: () => navigate("/about") },
            { label: "Courses", action: () => handleNavClick("services") },
            { label: "Contact Us", action: () => handleNavClick("contact") },
            { label: "Help", action: () => handleNavClick("faq") },
            { label: "Gallery", action: () => handleNavClick("gallery") },
            { label: "Placement", action: () => handleNavClick("placement") },
             { label: "Certifications", action: () => navigate("/certifications") },
          ].map((item, idx) => (
            <MobileNavLinkButton
              key={idx}
              onClick={() => {
                item.action();
                setMobileNavOpen(false);
              }}
            >
              {item.label}
            </MobileNavLinkButton>
          ))}

          {/* Mobile Resources Submenu */}
          <MobileNavLinkButton onClick={() => setShowResources(!showResources)}>
            Resources
          </MobileNavLinkButton>

          {showResources && (
            <MobileSubMenu>
              <MobileSubItem
                onClick={() => {
                   navigate("/tallycalculas");
                  setMobileNavOpen(false);
                }}
              >
                Tally Calculas
              </MobileSubItem>
              <MobileSubItem
                onClick={() => {
                  navigate("/govtskills");
                  setMobileNavOpen(false);
                }}
              >
                Govt. Skills Program
              </MobileSubItem>
            </MobileSubMenu>
          )}
        </MobileNav>
      </HeaderWrapper>
    </HeaderContainer>
  );
};

export default Header;

/* -------------------- Styled Components -------------------- */

const HeaderContainer = styled.div`
  position: relative;
`;

const HeaderWrapper = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) => props.theme.colors.extralight};
  padding: 0 20px;
  position: fixed;
  top: ${(props) => (props.isVisible ? "0" : "-100px")};
  width: 100%;
  z-index: 1000;
  transition: transform 0.3s ease-in-out;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Logo = styled.img`
  width: 90px;       /* desired width */
  height: auto;       /* maintain aspect ratio */
  display: block;     /* remove inline spacing below image */
`;


const CenterSection = styled.nav`
  display: flex;
  gap: 25px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled(ScrollLink)`
  cursor: pointer;
  font-size: 18px;
  color: ${(props) => props.theme.colors.dark};
  text-decoration: none;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
  }
`;

/* -------- Resources Dropdown -------- */

const ResourcesWrapper = styled.div`
  position: relative;
`;

const Dropdown = styled.div`
  position: absolute;
  top: 130%;
  left: 0;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 1001;
`;

const DropdownItem = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  font-size: 0.95rem;

  &:hover {
    background: ${(props) => props.theme.colors.extralight};
  }
`;

const RightSection = styled.div`
  display: flex;
`;

const MobileMenuIcon = styled.div`
  display: none;
  font-size: 1.6rem;
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
  }
`;

const MobileNav = styled.div`
  display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.secondary};
  width: 100%;
  position: absolute;
  top: 100%;
  left: 0;
  padding: 15px 20px;

  @media (min-width: 769px) {
    display: none;
  }
`;

const MobileNavLinkButton = styled.div`
  color: ${(props) => props.theme.colors.light};
  font-size: 1.125rem;
  padding: 10px 0;
  text-align: center;
  cursor: pointer;
`;

const MobileSubMenu = styled.div`
  padding-left: 15px;
`;

const MobileSubItem = styled.div`
  color: ${(props) => props.theme.colors.light};
  font-size: 1rem;
  padding: 8px 0;
  cursor: pointer;
`;
